export interface ILikeCounterResources {
  coolResource: string;
  counterDescription: string;
}

export const LikeCounterResources: ILikeCounterResources = {
  coolResource: "FAJNE",
  counterDescription: "Polubienia:",
};
